module.exports = __webpack_public_path__ + "name=img/src/assets/icons/ic_figma.svg?980fe878204cd4bedf9568cbec913959";